export const environment = {
  production: false,
  apiUrl: 'https://dev.webapi.danoral.com/api/v1',
};
